import { useEffect, useMemo, useRef, useState } from "react"
import { Urls } from "../../../services/Urls";
import services from "../../../services/services";
import _ from "underscore";
import { convertTo24HourFormat, dateConvert, timeStringToDate } from "../../../utils/Helper";

export const useCabinBooking = () => {

    const [showBooking, setShowBooking] = useState(false);
    const [bookCabinInfo, setBookCabinInfo] = useState({});
    const [view, setView] = useState("card");
    const [shiftTime, setShiftTime] = useState({});
    const [cabinList, setCabinList] = useState([]);
    const [cabinData, setCabinData] = useState([]);
    const [callApi, setCallApi] = useState(false);
    const tagRef = useRef(null);
    const [displaySlot, setDisplaySlot] = useState({time: {}, disable: []});
    const [loader, setLoader] = useState({cabin: false, history: false});

    useEffect(() => {
        getCabinList();
    }, [])

    useEffect(() => {
        view === "card" && !_.isEmpty(cabinList) && getCabinBookingDetails();
    }, [view, cabinList])

    const getCabinList = async () => {
        try {
            setCabinList([]);   
            setLoader((prev) => ({...prev, cabin: true}));
            const res = await services.getInvokeRemote("POST", Urls("GETCABINDETAILS"), {});
            if (res) {
                const data = res?.body?.data?.cabin_details_list;
                let cabinsArray = [];
                const floors = _.uniq(_.pluck(data, "floor_name"));
                floors?.forEach((floor) => {
                    let floorCabins = _.filter(data, { floor_name: floor });
                    floorCabins?.map((item) => {
                        item["name"] = item?.cabin_name
                    })
                    const obj = {
                        floor: floor,
                        cabins: floorCabins
                    }
                    cabinsArray.push(obj);
                })
                setCabinList(cabinsArray);
                setLoader((prev) => ({...prev, cabin: false}));
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({...prev, cabin: false}));
        }
    }

    const getCabinBookingDetails = async () => {
        try {
            setLoader((prev) => ({...prev, history: true}));
            const payload = {
                from_date: dateConvert(new Date(), "iso-string")?.split("T")?.[0] || "",
                to_date: dateConvert(new Date(), "iso-string")?.split("T")?.[0] || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("GETCABINBOOKINGDETAILS"), payload);
            if (res) {
                const data = res?.body?.data?.cabin_booking_details_list;
                const shiftData = res?.body?.data?.shift_details_get;
                if(!_.isEmpty(shiftData)) {
                    setShiftTime({ from: shiftData?.[0]?.shift_startdate ? shiftData?.[0]?.shift_startdate : "09:00:00", to: shiftData?.[0]?.shift_enddate ? shiftData?.[0]?.shift_enddate : "22:00:00" });
                } else {
                    setShiftTime({ from: "09:00:00", to: "22:00:00" });
                }

                // format cabin booking history data
                let dataObj = {};
                const currentDateTime = new Date();
                cabinList?.forEach((cabinParent) => {
                    cabinParent?.cabins?.forEach((cabin) => {
                        const bookingData = _.filter(data, (item) => item?.cabin_id === cabin?.cabin_id);

                        let isAvailable = true;
                        let currentBooking = null;
                        let futureBookings = [];

                        bookingData?.forEach((booking) => {
                            const from = new Date(booking?.from_datetime);
                            const to = new Date(booking?.to_datetime);

                            if (from <= currentDateTime && to > currentDateTime) {
                                isAvailable = false;
                                currentBooking = booking;
                            } else if (from > currentDateTime) {
                                futureBookings.push(booking);
                            }
                        });

                        const obj = {
                            data: bookingData
                        };
                        if (!isAvailable && currentBooking) {
                            obj["is_available"] = false;
                            obj["next_time"] = dateConvert(currentBooking?.to_datetime, "time");
                        } else {
                            obj["is_available"] = true;

                            if (!_.isEmpty(futureBookings)) {
                                const nextBooking = _.min(futureBookings, (item) =>
                                    new Date(item?.from_datetime).getTime()
                                );
                                obj["next_time"] = dateConvert(nextBooking?.from_datetime, "time");
                            } else {
                                obj["next_time"] = null;
                            }
                        }
                        dataObj[cabin?.cabin_id] = obj;
                    })
                })
                setCabinData(dataObj);
                setLoader((prev) => ({...prev, history: false}));
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({...prev, history: false}));
        }
    }

    const handleBookNow = (cabin) => {
        let disableArray = [];
        if(timeStringToDate(shiftTime?.from)?.getHours() < (new Date())?.getHours()) {
            disableArray.push({start: shiftTime?.from, end: convertTo24HourFormat(dateConvert(new Date(), "time"), true)});
        }
        setBookCabinInfo(cabin); 
        cabinData?.[cabin?.cabin_id]?.data?.forEach((item) => {
            disableArray.push({start: convertTo24HourFormat(dateConvert(item?.from_datetime, "time"), true), end: convertTo24HourFormat(dateConvert(item?.to_datetime, "time"), true)})
        })
        setDisplaySlot({time: {cell_start: shiftTime?.from, cell_end: shiftTime?.to}, disable: disableArray})
        setShowBooking(true);
    }

    return useMemo(() => ({
        cabinList, showBooking, setShowBooking, bookCabinInfo, view, setView, shiftTime, getCabinBookingDetails, callApi, setCallApi, getCabinList, cabinData, handleBookNow, displaySlot, loader, tagRef
    }), [cabinList, showBooking, setShowBooking, bookCabinInfo, view, setView, shiftTime, getCabinBookingDetails, callApi, setCallApi, getCabinList, cabinData, handleBookNow, displaySlot, loader, tagRef])
} 